"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardWidgetInsightGuard = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../../model");
// Sometimes this component is rendered even before insights are ready, which blows up.
// Since the behavior is nearly impossible to replicate reliably, let's be defensive here and not render
// anything until the insights "catch up".
exports.DashboardWidgetInsightGuard = function (props) {
    var widget = props.widget, Component = props.Component;
    var insights = model_1.useDashboardSelector(model_1.selectInsightsMap);
    var insight = insights.get(widget.insight);
    if (!insight) {
        // eslint-disable-next-line no-console
        console.debug("DefaultDashboardInsightWidget rendered before the insights were ready, skipping render.");
        return null;
    }
    return react_1.default.createElement(Component, tslib_1.__assign({}, props, { insight: insight }));
};
//# sourceMappingURL=DashboardWidgetInsightGuard.js.map